import { Spin } from "antd";
import { createContext, type ReactNode, useEffect, useState } from "react";
import { carregarDadosUsuario, getEntidadesDoUsuario, limparLogado } from "./auth/entidadeUsuario";
import { errorMessage } from "../messages/messages";



type EntidadeContextType = {
  matriculaEfpcSelecionada: string | undefined;
  setMatriculaEfpcSelecionada: React.Dispatch<React.SetStateAction<string|undefined>>;
};

type EntidadeProps = {
  children: ReactNode;
};

export const EntidadeContext = createContext({} as EntidadeContextType);

export function EntidadeContextProvider(props: EntidadeProps) {
  const [matriculaEfpcSelecionada, setMatriculaEfpcSelecionada] = useState<string|undefined>();
  const [loading, setLoading] = useState(false);

  //Função inicial
  useEffect(() => {
    async function carregarInicial(){
      setLoading(true);
      limparLogado();
      await carregarDadosUsuario().catch((error: any) => {
        //console.log(error);
      });

    //   const entidades = getEntidadesDoUsuario();
    //   if (entidades.length === 1){
    //     setMatriculaEfpcSelecionada(entidades[0].numero);
    //   } else if (entidades.length < 1) {
    //     errorMessage("Erro ao buscar lista de entidades. Se o erro persisitir entre em contato com o administrador do sistema.");
    //   }

      setLoading(false);
    }
    carregarInicial();
  }, []);

  if (loading) {
    return <div>Carregando dados...</div>; // fallback enquanto aguarda async
  }

  return (<>
      <Spin spinning={loading} delay={500}>
        <EntidadeContext.Provider
          value={{
            matriculaEfpcSelecionada,
            setMatriculaEfpcSelecionada
          }}
        >
          {props.children}
        </EntidadeContext.Provider>
      </Spin>
  </>);
}
